function handleLoginRedirect() {
  if (window.wave.analyticsData.customerId && !window.localStorage.getItem('customer_id')) {
    Shopify?.analytics?.publish('login_redirect', {
      user_id: window.wave.analyticsData.customerId,
      method: 'email',
      login_status: 'success',
      page_location: window.location.href,
      page_title: document.title
    });
    // Will be deleted after testing
    if (typeof gtag === 'function') {
      gtag('event', 'login_redirect', {
        user_id: window.wave.analyticsData.customerId,
        method: 'email',
        login_status: 'success',
        page_location: window.location.href,
        page_title: document.title
      });
    }
    // window.dataLayer.push({
    //   event: 'login_redirect',
    //   user_id: window.wave.customerId,
    //   method: 'email',
    //   login_status: 'success',
    //   page_location: window.location.href,
    //   page_title: document.title
    // });
    // gtag('event', 'login_redirect', {
    //   user_id: window.wave.customerId,
    //   method: 'email',
    //   login_status: 'success',
    //   page_location: window.location.href,
    //   page_title: document.title
    // });
  }
  window.localStorage.setItem('customer_id', window.wave.analyticsData.customerId);
}

function handleProductView() {
  Shopify?.analytics?.publish('product_view', window.wave.analyticsData.productObject);
  Shopify?.analytics?.publish('select_item', window.wave.analyticsData.productObject);

  // Will be deleted after testing
  if (typeof gtag === 'function') {
    gtag('event', 'product_view', window.wave.analyticsData.productObject);
    gtag('event', 'select_item', window.wave.analyticsData.productObject);
  }
}

function handlePageView() {
  Shopify?.analytics?.publish('page_view', window.wave.analyticsData.pageViewObject);
  if (typeof gtag === 'function') {
    gtag('event', 'page_view', window.wave.analyticsData.pageViewObject);
  }
}

function handleSearchSubmitted() {
  Shopify?.analytics?.publish('search', window.wave.analyticsData.searchSubmittedObject);
  if (typeof gtag === 'function') {
    gtag('event', 'search', window.wave.analyticsData.searchSubmittedObject);
  }
}

function handleScrollTracking() {
  // Define scroll thresholds to track
  const scrollThresholds = [25, 50, 75, 90, 100];
  const trackedThresholds = new Set();
  let ticking = false;

  function trackScrollDepth() {
    // Calculate scroll percentage
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollPercent = Math.round((scrollTop / documentHeight) * 100);

    // Check if we've reached any new thresholds
    scrollThresholds.forEach(threshold => {
      if (scrollPercent >= threshold && !trackedThresholds.has(threshold)) {
        trackedThresholds.add(threshold);
        
        // Send analytics data to Shopify
        Shopify?.analytics?.publish('scroll', {
          scroll_depth: threshold,
          scroll_units: "percent",
          page_location: window.location.href,
          page_title: document.title
        });

        if (typeof gtag === 'function') {
          gtag('event', 'scroll', {
            scroll_depth: threshold,
            scroll_units: "percent",
            page_location: window.location.href,
            page_title: document.title
          });
        }
      }
    });
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        trackScrollDepth();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Add scroll event listener
  window.addEventListener('scroll', onScroll, { passive: true });

  // Also track initial load if page is already scrolled
  trackScrollDepth();
}

function handleClickTracking(customSelectors = []) {
  // Default selectors for common interactive elements
  const defaultSelectors = [
    'a',           // Links
    'button',      // Buttons
    'input[type="button"]',
    'input[type="submit"]',
    'input[type="reset"]',
    '[role="button"]',  // Elements with button role
    'img',         // Images
    'svg',         // SVG icons
    '[onclick]',   // Elements with onclick handlers
    '[data-click]' // Elements with data-click attributes
  ];

  // Combine default and custom selectors
  const allSelectors = [...defaultSelectors, ...customSelectors];
  const selectorString = allSelectors.join(', ');

  // Helper function to get visible text from element
  function getElementText(element) {
    // For images, try alt text first, then title
    if (element.tagName === 'IMG') {
      return element.alt || element.title || '';
    }
    
    // For input elements, try value, then placeholder, then type
    if (element.tagName === 'INPUT') {
      return element.value || element.placeholder || element.type || '';
    }
    
    // For other elements, get visible text content
    let text = element.textContent || element.innerText || '';
    text = text.trim();
    
    // If no text found, try aria-label or title
    if (!text) {
      text = element.getAttribute('aria-label') || element.title || '';
    }
    
    // Limit text length to prevent overly long strings
    return text.length > 100 ? text.substring(0, 100) + '...' : text;
  }

  // Helper function to get URL from element
  function getElementUrl(element) {
    // Direct href attribute
    if (element.href) {
      return element.href;
    }
    
    // For elements inside links
    const parentLink = element.closest('a[href]');
    if (parentLink) {
      return parentLink.href;
    }
    
    // Check for data attributes that might contain URLs
    const dataUrl = element.dataset.url || element.dataset.href || element.dataset.link;
    if (dataUrl) {
      return dataUrl;
    }
    
    return '';
  }

  function getElementClasses(element) {
    return element.className ? element.className.toString().trim() : '';
  }

  function handleClick(event) {
    const element = event.target;

    if (!element.offsetParent && element.tagName !== 'HTML' && element.tagName !== 'BODY') {
      return;
    }
    
    if (element.disabled) {
      return;
    }

    const clickData = {
      click_text: getElementText(element),
      click_id: element.id || '',
      click_classes: getElementClasses(element),
      click_url: getElementUrl(element),
      page_location: window.location.href,
      page_title: document.title,
      element_tag: element.tagName.toLowerCase(),
      element_type: element.type || ''
    };

    Shopify?.analytics?.publish('click', clickData);
    if (typeof gtag === 'function') {
      gtag('event', 'click', clickData);
    }
  }

  // Add click event listener to document with event delegation
  document.addEventListener('click', function(event) {
    // Check if the clicked element matches any of our selectors
    if (event.target.matches(selectorString)) {
      handleClick(event);
    } else {
      // Check if any parent element matches (for nested elements)
      const matchingParent = event.target.closest(selectorString);
      if (matchingParent) {
        // Create a new event object with the matching parent as target
        const parentEvent = { ...event, target: matchingParent };
        handleClick(parentEvent);
      }
    }
  }, true);
}

function handleRecipeBlogItemClick() {
  document.addEventListener('click', function(event) {
    const blogItem = event.target.closest('.js-blog-item');
    
    if (!blogItem) {
      return;
    }

    const templateSuffix = blogItem.dataset.templateSuffix;
    if (templateSuffix !== 'recipe') {
      return;
    }

    const recipeData = {
      page_location: window.location.href,
      page_title: document.title,
      recipe_title: blogItem.dataset.articleTitle || '',
      difficulty: blogItem.dataset.recipeDifficulty,
      serves: blogItem.dataset.recipeServes,
      cooking_time: blogItem.dataset.recipeCookingTime,
      preparation: blogItem.dataset.recipePreparation,
      recipe_tags: blogItem.dataset.articleTags || '',
      item_name: blogItem.dataset.itemName || '',
      item_id: blogItem.dataset.itemId || '',
      price: blogItem.dataset.price || '',
      saucetype: blogItem.dataset.sauceType || ''
    };

    const cookingStoriesData = {
      page_location: window.location.href,
      page_title: document.title,
      item_name: blogItem.dataset.itemName || '',
      item_id: blogItem.dataset.itemId || '',
      price: blogItem.dataset.price || '',
      saucetype: blogItem.dataset.sauceType || ''
    }

    Shopify?.analytics?.publish('recipes_blog', recipeData);
    Shopify?.analytics?.publish('cooking_stories', cookingStoriesData);
    // Will be deleted after testing
    if (typeof gtag === 'function') {
      gtag('event', 'recipes_blog', recipeData);
      gtag('event', 'cooking_stories', cookingStoriesData);
    }
  }, true);
}

window.addEventListener('DOMContentLoaded', () => {
  handlePageView();
  handleLoginRedirect();
  handleScrollTracking();
  
  const customSelectors = [];
  handleClickTracking(customSelectors);
  
  if (window.wave.template === 'product') {
    handleProductView();
  }
  if (window.wave.template === 'search') {
    handleSearchSubmitted();
  }

  if (window.wave.template === 'blog') {
    handleRecipeBlogItemClick();
  }
});
